var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L2.25 5.25L3.3 4.1625L5.25 6.1125V0H6.75V6.1125L8.7 4.1625L9.75 5.25L6 9ZM1.5 12C1.0875 12 0.734375 11.8531 0.440625 11.5594C0.146875 11.2656 0 10.9125 0 10.5V8.25H1.5V10.5H10.5V8.25H12V10.5C12 10.9125 11.8531 11.2656 11.5594 11.5594C11.2656 11.8531 10.9125 12 10.5 12H1.5Z",
    fill: "url(#paint0_linear_1105_6283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1105_6283",
    x1: 0,
    y1: 6,
    x2: 12,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1a9351922871e745b70fdce1fee37e11.svg";
export { ForwardRef as ReactComponent };